export default "__VITE_ASSET__ZJ8kFDQI__"